'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { View } from 'foundations-components/components/View';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Select } from 'foundations-components/transitional/components/Select';
import ConfigurationPanelHeader from './ConfigurationPanelHeader';
import AsyncImageBrowserAndUploder from 'FormsUI/components/common/AsyncImageBrowserAndUploder';
import RatioSteppers from 'FormsUI/components/common/RatioSteppers';
import { ALIGNMENT_OPTIONS } from 'FormsCommonComponents/constants/RichTextImage';
import { ConfigPanelWrapper } from 'FormsUI/components/editor/form/configuration/ConfigPanelWrapper';
import { FormFieldConfigHeader } from 'FormsUI/components/editor/form/configuration/FormFieldConfigHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = suffix => `editor.form.config.image.${suffix}`;
const getAlignmentOptions = () => {
  return Object.keys(ALIGNMENT_OPTIONS).map(key => {
    return {
      value: ALIGNMENT_OPTIONS[key],
      text: I18n.text(langKey(`alignmentOption.${key}`))
    };
  });
};
const ImageButton = ({
  imageSrc,
  updateImageFile
}) => {
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "config-editor-input-field",
    "data-editable-field": "image-upload",
    children: /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('srcLabel')
      }),
      children: /*#__PURE__*/_jsx(AsyncImageBrowserAndUploder, {
        imageUrl: imageSrc,
        onChange: updateImageFile
      })
    })
  });
};
export const AltText = ({
  altText,
  updateAltText
}) => /*#__PURE__*/_jsx("div", {
  "data-test-id": "config-editor-input-field",
  children: /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('altTextLabel')
    }),
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('altTextTooltip')
    }),
    tooltipPlacement: "right",
    children: /*#__PURE__*/_jsx(TextInput, {
      value: altText,
      use: "on-dark",
      onChange: ({
        target: {
          value
        }
      }) => updateAltText(value),
      "data-editable-field": "alt-text",
      "data-test-id": "alt-text-input"
    })
  })
});
export const Alignment = ({
  alignment,
  updateAlignment
}) => /*#__PURE__*/_jsx("div", {
  "data-test-id": "config-editor-input-field",
  children: /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('alignmentLabel')
    }),
    children: /*#__PURE__*/_jsx(Select, {
      options: getAlignmentOptions(),
      value: alignment,
      buttonUse: "form-on-dark",
      onChange: ({
        target: {
          value
        }
      }) => updateAlignment(value),
      "data-editable-field": "alignment",
      "data-test-id": "alignment-select"
    })
  })
});
export const ImageSize = ({
  aspectRatio,
  width,
  height,
  isMaxWidth,
  updateWidth,
  updateHeight,
  updateAspectRatio,
  toggleImageMaxWidth
}) => /*#__PURE__*/_jsx("div", {
  "data-test-id": "config-editor-input-field",
  children: /*#__PURE__*/_jsx(RatioSteppers, {
    isLockDisabled: true,
    isLocked: true,
    aspectRatio: aspectRatio,
    isMaxWidth: isMaxWidth,
    toggleMaxWidthLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('toggleMaxWidthLabel')
    }),
    leftStepper: {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('width')
      }),
      value: width,
      onChange: updateWidth
    },
    rightStepper: {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('height')
      }),
      value: height,
      onChange: updateHeight
    },
    onLoad: updateAspectRatio,
    onToggleMaxWidth: toggleImageMaxWidth
  })
});
const ImageConfigurationPanel = ({
  hideConfigurationPanel,
  altText,
  aspectRatio,
  imageSrc,
  alignment,
  width,
  height,
  isMaxWidth,
  updateImageFile,
  updateWidth,
  updateHeight,
  updateAltText,
  updateAlignment,
  updateAspectRatio,
  toggleImageMaxWidth
}) => /*#__PURE__*/_jsxs(ConfigPanelWrapper, {
  "data-commenting-scroll-container": true,
  children: [/*#__PURE__*/_jsx(ConfigurationPanelHeader, {
    handleDone: hideConfigurationPanel
  }), /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "1200",
    children: /*#__PURE__*/_jsx(FormFieldConfigHeader, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('header')
      })
    })
  }), /*#__PURE__*/_jsxs(View, {
    padding: "600",
    children: [/*#__PURE__*/_jsx(ImageButton, {
      imageSrc: imageSrc,
      updateImageFile: updateImageFile
    }), /*#__PURE__*/_jsx(AltText, {
      altText: altText,
      updateAltText: updateAltText
    }), /*#__PURE__*/_jsx(ImageSize, {
      imageSrc: imageSrc,
      aspectRatio: aspectRatio,
      isMaxWidth: isMaxWidth,
      width: width,
      height: height,
      updateWidth: updateWidth,
      updateHeight: updateHeight,
      updateAspectRatio: updateAspectRatio,
      toggleImageMaxWidth: toggleImageMaxWidth
    }), /*#__PURE__*/_jsx(Alignment, {
      alignment: alignment,
      updateAlignment: updateAlignment
    })]
  })]
});
export default ImageConfigurationPanel;